// eslint-disable-next-line import/prefer-default-export
export const requestReport = {
  reportType: 'Existing Report', name: '', email: '', reportName: '', description: '',
};
